import {
  sendFeedback as sendFeedbackEmailAPI,
  sendCollaboratorEmail as sendCollaboratorEmailAPI,
  exerciseCompletion as sendExerciseCompletionEmailAPI,
} from "@nualang/nualang-api-and-queries/APIs/Notifications";
import logger from "../../logger";
import config from "../../config";

export const sendFeedbackEmail = async (
  emails,
  username,
  creatername,
  feedback,
  contentname,
  contenttype,
  link,
  state,
) => {
  try {
    let recipients = emails;
    if (recipients.length === 0) {
      return false;
    }
    const email = {
      recipients,
      params: {
        feedback: feedback,
        contentname: contentname,
        contenttype: contenttype,
        username: username,
        creatername: creatername,
        link: link,
        state: state,
      },
    };
    const response = await sendFeedbackEmailAPI(email);
    return response;
  } catch (error) {
    logger.error(error);
    return false;
  }
};

export const sendExerciseCompletionEmail = async (
  emails,
  studentname,
  creatername,
  contentname,
  contenttype,
  link,
) => {
  try {
    let recipients = emails;
    if (recipients.length === 0) {
      return false;
    }
    const email = {
      recipients,
      params: {
        contentname: contentname,
        contenttype: contenttype,
        studentname: studentname,
        creatername: creatername,
        link: link,
      },
    };
    const response = await sendExerciseCompletionEmailAPI(email);
    return response;
  } catch (error) {
    logger.error(error);
    return false;
  }
};

export const sendCollaboratorEmail = async (
    userIds,
    contentName,
    contentType,
    courseCollaborators,
    id,
    creatorName,
  ) => {
    try {
      let recipients = userIds;
      recipients = userIds.filter(
        (email) => !courseCollaborators.includes(email),
      );
      if (recipients.length === 0) {
        return false;
      }
      const email = {
        recipients,
        params: {
          contentName: contentName,
          contentType: contentType,
          creatorName: creatorName,
          inviteLink: `${config.APP_URL}/courses/${id}?newCollaborator=true`,
        },
      };
      const response = await sendCollaboratorEmailAPI(email);
      return response;
    } catch (error) {
      logger.error(error);
      return false;
    }
  };